import React, { useState } from 'react'
import { connect } from 'dva'
import curry from 'lodash-es/curry'
import get from 'lodash-es/get'
import PropTypes from 'prop-types'
import { SIDEBAR_SAVED_TABS } from '../../../../lib/constants'
import ActiveLayersTabContent from '../ActiveLayersTabContent'
import AllLayersTabContent from '../AllLayersTabContent'
import Chip from '../../../Chip'
import FavoriteLayersTabContent from '../FavoriteLayersTabContent'
import GHAnimatedLogo from '../../../../assets/svg/GHAnimatedLogo'
import styles from '../LayersContent.module.scss'

function LayersContent(props) {
  // const [activeTab, setActiveTab] = useState(props.activeTab)

  const chipSelected = curry((tabName, e) => {
    // setActiveTab(tabName)
    props.dispatch({
      type: 'app/updateMetadata',
      payload: { savedLayersTab: tabName },
    })

    props.dispatch({
      type: 'features/resetAllSelectedFeatures',
    })
  })

  const chipItems = [
    {
      title: 'All',
      tab: SIDEBAR_SAVED_TABS.Layers.All,
      component: <AllLayersTabContent />
    },
    {
      title: 'Favorites',
      tab: SIDEBAR_SAVED_TABS.Layers.Favorites,
      component: <FavoriteLayersTabContent />
    },
    {
      title: 'Active',
      tab: SIDEBAR_SAVED_TABS.Layers.Active,
      component: <ActiveLayersTabContent />
    },
  ]

  return (
    <>
      {props.allLayersLoading ? (
        <div className={styles.ghLoader}>
          <GHAnimatedLogo width={72} height={108} />
          <p>Loading Layers...</p>
        </div>
      ) : (
        <div className={styles.layerItems}>
          {chipItems.map((ci, i) => {
            const isActive = ci.tab === props.activeTab
            return (
              <Chip
                key={i}
                onClick={chipSelected(ci.tab)}
                size={Chip.SIZE.small}
                theme={isActive ? Chip.THEME.white : Chip.THEME.outlinePrimary}
              >
                {ci.title}
              </Chip>
            )
          })}
        </div>
      )}
      {chipItems.find((ci) => ci.tab === props.activeTab).component}
    </>
  )
}

LayersContent.propTypes = {
  activeTab: PropTypes.string,
  allLayersLoading: PropTypes.bool,
}

export default connect((model) => {
  const { allLayersLoading } = model.layers
  const { sidebarView } = model.app
  const { All } = SIDEBAR_SAVED_TABS.Layers
  const activeTab = get(sidebarView, ['metadata', 'savedLayersTab'], All)
  return {
    activeTab,
    allLayersLoading
  }
})(LayersContent)
